import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { RequireAuth } from '@/auth/RequireAuth'
import { FullPageLoader } from '@/components/common/FullPageLoader'
import { OnboardingLayout } from '@/components/layout/OnboardingLayout'
import { ROUTES } from './paths'

/**
 * Post-sign-up onboarding routes.
 *
 * Registration ends with an administrator approving the account and a second
 * OTP activating it. Both steps live on the account-status page, which renders
 * in a centered, chrome-free {@link OnboardingLayout} instead of the
 * authenticated {@link AppShell}, so an account that is not active yet never
 * sees the dashboard navigation. The awaiting-access notice brings its own
 * layout: an active account with no group has nothing to show in the shell yet.
 */
const ActivationPage = lazy(() => import('@/pages/ActivationPage'))
const AwaitingAccessPage = lazy(() => import('@/pages/AwaitingAccessPage'))

export const onboardingRoutes: RouteObject[] = [
  {
    element: (
      <RequireAuth>
        <OnboardingLayout />
      </RequireAuth>
    ),
    children: [
      {
        path: ROUTES.activation,
        element: (
          <Suspense fallback={<FullPageLoader label="Loading…" contained />}>
            <ActivationPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: ROUTES.awaitingAccess,
    element: (
      <RequireAuth>
        <Suspense fallback={<FullPageLoader label="Loading…" />}>
          <AwaitingAccessPage />
        </Suspense>
      </RequireAuth>
    ),
  },
]
